export const ConfigFiles = {
    HOME_PAGE_GRID: "homepage/image_gallery/homepage_grid_config.json "
}

